"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var config = {
  name: 'VDP',
  owner: {
    gusTeam: 'TBD'
  },
  publication: {
    inferredBy: [{
      classifiers: ['vdp']
    }],
    files: [{
      id: 'vdp',
      classifier: 'vdp',
      packaging: 'vdp'
    }],
    minimumInputSets: [{
      files: ['vdp']
    }]
  },
  keywords: ['vdp']
};
var _default = exports.default = config;
//# sourceMappingURL=config.js.map